import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, Icon, ListView, Card, WingBlank, WhiteSpace, Badge } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import DataFetcher from '../utils/DataFetcher';
import { createForm } from 'rc-form';
import '../styles/AgentCouponGrabbed.css';
import CommonUtils from '../utils/CommonUtils';
import Constants from '../utils/Constants';
import imgAvatar from '../medias/avatar.svg';

const history = require("history").createHashHistory()

class OperatorCouponGrabbed extends Component {
    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4,
            couponActivity: {},
            deviceTypes: []
        }
    }

    componentDidMount() {
        this.activityId = CommonUtils.resolveSearchParam(this.props.location, 'activityId')
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 65;
        this.setState({
            height
        })
        this.loadDeviceTypes()
        this.loadCouponActivity()
        this.loadPageData(1)
    }

    loadDeviceTypes = () => {
        DataFetcher.deviceTypes({}, {
            success: (resp) => {
                this.setState({
                    deviceTypes: resp.data
                })
            }
        })
    }

    loadCouponActivity = () => {
        DataFetcher.agentActivityDetail({
            activityId: this.activityId
        }, {
            success: (resp) => {
                this.setState({
                    couponActivity: resp.data
                })
            },
            completed: () => {
            }
        })
    }

    loadPageData = (pageNum) => {
        DataFetcher.agentGrabbedCoupons({
            pageNum,
            pageSize: 10,
            activityId: this.activityId
        }, {
            success: (resp) => {
                let data = resp.data
                this.pageNum = data.pageNum;
                this.pageSize = data.pageSize;
                this.pages = data.pages;
                let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : {}
                this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
                this.setState({
                    dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                    isLoading: false,
                    hasMore: this.pageNum < this.pages,
                })
            },
            completed: () => {
                this.setState({
                    isLoading: false
                })
            }
        })
    }

    onEndReached = (event) => {
        const { isLoading, hasMore } = this.state

        if (isLoading || !hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadPageData(++this.pageNum)
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.forEach((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
        })
        return rowDatas;
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    generateInfoRowForCouponType = (rowData) => {
        const { couponActivity } = this.state
        let couponType = couponActivity.couponType

        let discountScope = '不限'
        if(couponActivity.bottomAmount && couponActivity.topAmount) {
            discountScope = `￥${couponActivity.bottomAmount} ~ ￥${couponActivity.topAmount}`
        } else if(couponActivity.bottomAmount) {
            discountScope = `最低￥${couponActivity.bottomAmount}`
        } else if(couponActivity.topAmount) {
            discountScope = `最高￥${couponActivity.topAmount}`
        }

        if(couponType === 'GAME_MINUTES') {
            return (
                <div className='info-row'>
                    <div className='info-column word-ellipsis'>
                        <span className='label'>游戏时间：</span> 
                        <span className='value'>{rowData.gameMinutes}分钟</span>
                    </div>
                    <div className='info-column word-ellipsis'>
                        <span className='label'>优惠类型：</span> 
                        <span className='value'>{Constants.DICT_COUPON_TYPE[couponActivity.couponType]}</span>
                    </div>
                </div>
            )
        } else if(couponType === 'PACKET_DISCOUNT') {
            return (
                <div className='info-row'>
                    <div className='info-column word-ellipsis'>
                        <span className='label'>套餐折扣：</span> 
                        <span className='value'>{rowData.discount}%</span>
                    </div>
                    <div className='info-column word-ellipsis'>
                        <span className='label'>适用套餐：</span> 
                        <span className='value'>{discountScope}</span>
                    </div>
                </div>
            )
        }
    }

    generateInfoRowForGrabWay = (rowData) => {
        const { couponActivity } = this.state
        let grabWay = couponActivity.grabWay

        if(grabWay === 'PAPER_COUPON') {
            return (
                <div className='info-row'>
                    <div className='info-column word-ellipsis'>
                        <span className='label'>优惠券码：</span> 
                        <span className='value'>{rowData.couponCode}</span>
                    </div>
                    <div className='info-column word-ellipsis'>
                        <span className='label'>领券方式：</span> 
                        <span className='value'>{Constants.DICT_COUPON_GRAB_WAY[couponActivity.grabWay]}</span>
                    </div>
                </div>
            )
        } else if(grabWay === 'OFFLINE_QRCODE') {
            return (
                <div className='info-row'>
                    <div className='info-column word-ellipsis'>
                        <span className='label'>发券人员：</span> 
                        <span className='value'>{rowData.operatorName}</span>
                    </div>
                    <div className='info-column word-ellipsis'>
                        <span className='label'>发券微信：</span> 
                        <span className='value'>{rowData.operatorNickName}</span>
                    </div>
                </div>
            )
        } else if(grabWay === 'ONLINE_QRCODE') {
            return (
                <div className='info-row'>
                    <div className='info-column word-ellipsis'>
                        <span className='label'>优惠券码：</span> 
                        <span className='value'>{rowData.couponCode}</span>
                    </div>
                    <div className='info-column word-ellipsis'>
                        <span className='label'>领券方式：</span> 
                        <span className='value'>{Constants.DICT_COUPON_GRAB_WAY[couponActivity.grabWay]}</span>
                    </div>
                </div>
            )
        }
    }

    renderRow = (rowData, sectionId, rowId) => {
        const { couponActivity } = this.state 

        let statusText = Constants.DICT_COUPON_STATUS[rowData.status]
        let statusColor = 'gray'
        if(rowData.status === 'TO_EXCHANGE') {
            statusColor = '#04bbc5'
        }
        let tagBadge = (<Badge text={statusText} style={{backgroundColor: statusColor}}/>)
        return (
            <WingBlank size='sm'>
                <div>
                    <Card key={rowId}>
                        <Card.Header
                            title={<span className='word-ellipsis'>&nbsp;{rowData.nickName?rowData.nickName:'游客'}</span>}
                            thumb={<img src={rowData.avatar?rowData.avatar:imgAvatar} alt='avatar'/>}
                            extra={tagBadge}
                        />
                        <Card.Body>
                            {this.generateInfoRowForCouponType(rowData)}
                            {this.generateInfoRowForGrabWay(rowData)}
                        </Card.Body>
                        <Card.Footer content={<span className='word-ellipsis'>{couponActivity?CommonUtils.resolveDictText(couponActivity.deviceType, this.state.deviceTypes, 'code', 'name'):null}</span>} extra={<span className='word-ellipsis'>{rowData.modifyTime}</span>}/>
                    </Card>
                </div>
            </WingBlank>
        )
    }

    render() {
        const { dataSource, isLoading, couponActivity } = this.state;

        return (
            <div className='page-agent-coupon-grabbed'>
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                >
                    <div className='word-ellipsis' style={{maxWidth: 200}}>{couponActivity.name?`领券记录-${couponActivity.name}`:'领券记录'}</div>
                </NavBar>
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 50
                    }}
                />
            </div>
        )
    }
}

export default createForm()(OperatorCouponGrabbed);


// WEBPACK FOOTER //
// ./src/modules/AgentCouponGrabbed.js